/**
 * 튜닝 사례의 선택 칸(2026-10-11) — 용도 · 성능 근거 · 결과 동등성. 값 목록은 백엔드 `tuningCase/store.js` 와 같아야 한다
 * (어긋나면 화면에는 뜨는데 서버가 조용히 버린다).
 */
export const USAGES = ['ref', 'edu', 'challenge'];
export const PERF_BASIS = ['measuredFull', 'measuredPartial', 'estimated', 'none'];
export const RESULT_SAME = ['checked', 'unchecked'];

/** 용도를 정하지 않았을 때 — 서버(`derivedUsage`)와 같은 규칙: 전/후 SQL 과 실행계획이 다 있으면 AI 참조, 아니면 교육 */
export function derivedUsage(c) {
    const has = (k) => !!String((c && c[k]) || '').trim();
    return has('beforeSql') && has('afterSql') && has('beforePlan') && has('afterPlan') ? ['ref'] : ['edu'];
}

/**
 * 사례의 그림(원문의 설명용 이미지) 주소 — 서버가 볼 수 있는 사람에게만 준다(주인, 또는 범용 사례에서 공개한 그림).
 * 쿠키로 인증하는 같은 출처 경로라 <img> 로 바로 그린다.
 */
const FIGURE_BASE = process.env.REACT_APP_API_BASE_URL || '/sql-developer';
export const figureUrl = (id) => `${FIGURE_BASE}/assistant/tuning-cases/figures/${encodeURIComponent(id)}`;
export const MAX_FIGURES = 12;
/** 그림의 폭(본문 폭 대비 %)과 배경 — 값 목록은 백엔드 `tuningCase/figureStore.js` 와 같아야 한다 */
export const FIGURE_BGS = ['light', 'dark', 'none'];
export const FIGURE_WIDTH = { min: 20, max: 100, step: 5 };
/**
 * 문서(마크다운)에 싣는 그림 주소 — 폭·배경을 주소 조각(#w=60&bg=dark)에 적는다. 마크다운 이미지는 속성을 못 싣고,
 * 조각은 서버로 가지 않으므로 주소는 그대로 유효하다. 그리는 쪽(ReportView)이 `figureStyleOf` 로 읽는다.
 */
export const figureSrc = (f) => `${figureUrl(f.id)}#w=${Number(f.width) || 100}&bg=${FIGURE_BGS.includes(f.bg) ? f.bg : 'light'}`;
export function figureStyleOf(src) {
  const m = /#(.*)$/.exec(String(src || ''));
  const q = new URLSearchParams(m ? m[1] : '');
  const w = Math.round(Number(q.get('w')));
  const bg = q.get('bg');
  return {
    width: Number.isFinite(w) && w >= FIGURE_WIDTH.min && w <= FIGURE_WIDTH.max ? w : 100,
    bg: FIGURE_BGS.includes(bg) ? bg : 'light',
  };
}
